export const WIDGET_OPEN = 'widget_open';
export const WIDGET_CLOSE = 'widget_close';
export const CONVERSATION_OPEN = 'conversation_open';
export const CONVERSATION_CLOSE = 'conversation_close';
export const MESSAGE_SEND = 'message_send';
